<template>
  <v-layout>
    <v-card>
      <app-card-header
        class="controlled-font"
        icon="mdi-information-outline"
        :text="siteText.ui.testInformationTitle"
      ></app-card-header>
      <v-card-text class="controlled-font">
        <v-layout>
          <v-flex class="sm12 black--text">
            <p v-html="testInformation"></p>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="sm3">
            <v-btn class="primary controlled-font" @click="agree">
              <v-icon left>
                mdi-check-circle-outline
              </v-icon>
              {{ siteText.ui.agree }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

import appCardHeader from "./ui/CardHeader.vue";
export default {
  components: {
    appCardHeader,
  },
  props: {
    testInformation: String,
  },
  computed: {
    ...mapGetters(["siteText"]),
  },
  methods: {
    agree() {
      this.$emit("termsAgreed");
    },
  },
};
</script>

<style scoped>
.v-card {
  width: 100% !important;
}
</style>
